import { render, staticRenderFns } from "./ImportChecklistModal.vue?vue&type=template&id=22a2b02d&scoped=true&"
import script from "./ImportChecklistModal.vue?vue&type=script&lang=ts&"
export * from "./ImportChecklistModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2b02d",
  null
  
)

export default component.exports